import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import {
  margin,
  styles,
  p1Styles,
  p2styles,
  p3styles,
  pad,
} from "./modules/Dashboard/DummyPdfs/Pdf2Components/styles/pdf2Style";

export const priority_of_issuance = [
  {
    id: 1,
    name: "HIGH",
  },
  {
    id: 2,
    name: "MEDIUM",
  },
  {
    id: 3,
    name: "LOW",
  },
];

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  // Add leading zero if month or day is less than 10
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;

  return `${year}-${month}-${day}`;
};


export const vrfDownloadDropdown = [
  {
    id:1,
    value : "DRAFT VRF"
  },
  {
    id:2,
    value:"FINAL VRF"
  },
  {
    id:3,
    value : "PAYENT RECEIPT"
  }
]
